import root from 'window-or-global';
import {ProtocolBridge} from '../protocolBridge';
import {createClassLogger, Logger} from '../../utils/Logging';

export const logger: Logger = createClassLogger('ProtocolBridge:Launcher');

export const PROTOCOL_LAUNCHER = 'com.epicgames.launcher';

export const ADD_FRIENDS_URL = 'social/friends/add';
export const ADD_FRIENDS_REQUESTS_URL = `${ADD_FRIENDS_URL}?tab=requests`;
export const ADD_FRIENDS_SUGGESTIONS_URL = `${ADD_FRIENDS_URL}?tab=suggestions`;
export const ADD_FRIENDS_CONNECTIONS_URL = `${ADD_FRIENDS_URL}?tab=connections`;

export const SETTINGS_URL = 'settings';
export const SOCIAL_PANEL_URL = 'social/friends/list';
export const UE_PAGE_URL = 'ue';

const sendProtocolNavigation = async (method: string, uri: string): Promise<boolean> => {
    const url = `${PROTOCOL_LAUNCHER}://${uri}`;
    logger.log(method, `NAVIGATE: ${url}`);
    if (!root || !root.location) return false;

    if (root.location.assign) {
        root.location.assign(url);
    } else {
        root.location.href = url;
    }
    return true;
};

const sendProtocolOpen = async (method, uri): Promise<boolean> => {
    const url = `${PROTOCOL_LAUNCHER}://${uri}`;
    logger.log(method, `OPEN: ${url}`);
    if (!root || !root.open) return false;

    root.open(url);
    return true;
};

const protocolLauncher: ProtocolBridge = {
    navigateToUe: (): Promise<boolean> => sendProtocolNavigation('navigateToUe', UE_PAGE_URL),
    openAddFriends: (): Promise<boolean> => sendProtocolOpen('openAddFriends', ADD_FRIENDS_URL),
    openAddFriendRequests: (): Promise<boolean> =>
        sendProtocolOpen('openAddFriendRequests', ADD_FRIENDS_REQUESTS_URL),
    openAddFriendSuggestions: (): Promise<boolean> =>
        sendProtocolOpen('openAddFriendSuggestions', ADD_FRIENDS_SUGGESTIONS_URL),
    openAddFriendConnections: (): Promise<boolean> =>
        sendProtocolOpen('openAddFriendConnections', ADD_FRIENDS_CONNECTIONS_URL),
    openSettings: (): Promise<boolean> => sendProtocolOpen('openSettings', SETTINGS_URL),
    openSocialPanel: (): Promise<boolean> => sendProtocolOpen('openSocialPanel', SOCIAL_PANEL_URL)
};

export default protocolLauncher;
